import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { AirlineIcon } from "@tenant/ui";
import styles from "./styles.module.scss";

export const FlightSummaryDetails = ({
  duration,
  primaryCarrier,
  airlineName,
  flightStops,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "FlightSummaryDetails");

  return (
    <div className={block}>
      <div className={cn("icon")}>
        <AirlineIcon
          airlineCode={primaryCarrier}
          altText={airlineName}
          className={styles["airline__icon"]}
        />
      </div>

      <div className={cn("flight-details")}>
        <div className={cn("duration")}>{duration}</div>
        <div className={cn("dot")}>{"•"}</div>
        <div className={cn("stops")}>
          {flightStops === 0
            ? t("stopDetails.nonstop")
            : t("stopDetails.stop", { count: flightStops })}
        </div>
      </div>

      <div className={cn("airline-details")}>
        <div className={cn("airline")}>{airlineName}</div>
      </div>

      <div className={cn("view-fares")}>{t("flightCard.viewFares")}</div>
    </div>
  );
};
